import React, { useRef } from "react";
import { Row, Col, Drawer, Space, Tooltip, Popconfirm, Modal } from "antd";
import { useForm } from "react-hook-form";
import { LazerOpenModalButton } from "./buttons/LazerOpenModalButton";
import { FrontLazerCanvas } from "./canvas/FrontLazerCanvas";
import { BackLazerCanvas } from "./canvas/BackLazerCanvas";
import { LazerCanvasConfigurator } from "./canvas-configurators/LazerCanvasConfigurator";
import { FrontLazerDamageCanvas } from "./canvas/FrontLazerStep2";
import { BackLazerDamageCanvas } from "./canvas/BackLazerStep2";
import { LazerCanvasStep2 } from "./canvas/LazerCanvasStep2";
import { EditBrushIcon } from "../icons/EditBrushIcon";
import { DamageIndicatorIcon } from "../icons/DamageIndicatorIcon";
import html2canvas from "html2canvas";
//@ts-ignore
import { useScreenshot, createFileName } from "use-react-screenshot";
import { OrderButton } from "./buttons/OrderButton";
import { useSelector } from "react-redux";
import { InfoCircleOutlined, CloseOutlined } from "@ant-design/icons";

export type ILazerFormProps = {
  handleSceenShorts: any;
  handleChange: any;
  handleSceenShortsTypeLazer: any;
  handleImageTypes: (laser_file_type_design: {
    file: any;
    color: string;
  }) => void;

  deleteImageTypes: any;
  globalData: any;
  mouseMoveFrontLazer: (mousePosition: { x: number; y: number }) => void;
  mouseMoveBackLazer: (mousePosition: { x: number; y: number }) => void;

  mouseClickFrontLazerDesign: (mousePosition: {
    id: string;
    x: number;
    y: number;
    color: string;
  }) => void;
  mouseClickBackLazerDesign: (mousePosition: {
    id: string;
    x: number;
    y: number;
    color: string;
  }) => void;
  deletePositionFiles: (id: string, attribute: string) => void;
};
const LazerForm: React.FC<ILazerFormProps> = ({
  handleSceenShorts,
  handleChange,
  handleSceenShortsTypeLazer,
  handleImageTypes,
  deleteImageTypes,
  globalData,
  mouseMoveFrontLazer,
  mouseMoveBackLazer,
  mouseClickFrontLazerDesign,
  mouseClickBackLazerDesign,
  deletePositionFiles,
}) => {
  const laserTypeRef = React.useRef(null);
  const laserRef = React.useRef(null);
  const [imageTypeLaser, takeScreenshotTypeLaser] = useScreenshot();
  const [imageLaser, takeScreenshotLaser] = useScreenshot();
  const [clearButton, setClear] = React.useState(0);
  const Clear = () => {
    setClear(clearButton + 1);
  };

  const [drawerOpened, setDrawerOpened] = React.useState(false);
  const [done, setDone] = React.useState(false);
  // const { register, control, handleSubmit, watch, errors } = useForm();
  const [current, setCurrent] = React.useState(1);
  const [ImgLaser, setImgLaser] = React.useState<any>();
  const [ImgTypeLaser, setImgTypeLaser] = React.useState<any>();
  const [deleteBrush, setDeleteBrush] = React.useState(false);
  const lazerbtnNext = document.getElementById("lazer-canvas-btn-next");
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const download = (image: any, { name = "img", extension = "png" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const screenShotHandlerTypeLaser = () => {
    console.log("capture-design");
    const cap: any = document.querySelector("#capture-design");
    html2canvas(cap, { useCORS: true }).then(async (canvas) => {
      var fullQuality = canvas.toDataURL("image/jpeg", 1.0);
      const filename = (Math.random() + 1).toString(36).substring(7);
      const file = await dataUrlToFile(fullQuality, `${filename}.jpg`);
      handleSceenShortsTypeLazer("laser_images_design", [file]);
    });
  };

  const screenShotLaserHandler = () => {
    console.log("capture-drawing");
    const cap: any = document.querySelector("#capture");
    html2canvas(cap, { useCORS: true }).then(async (canvas) => {
      var fullQuality = canvas.toDataURL("image/jpeg", 1.0);
      const filename = (Math.random() + 1).toString(36).substring(7);
      const file = await dataUrlToFile(fullQuality, `${filename}.jpg`);
      handleSceenShorts("laser_images_drawing", [file]);
    });

    // setCurrent(current + 1);
  };
  const [close, setClose] = React.useState(false);
  async function dataUrlToFile(
    dataUrl: string,
    fileName: string
  ): Promise<File> {
    const res: Response = await fetch(dataUrl);
    const blob: Blob = await res.blob();
    return new File([blob], fileName, { type: "image/png" });
  }

  // React.useEffect(() => {
  //   if (ImgTypeLaser) {
  //     handleSceenShortsTypeLazer(
  //       "laser_type_images",
  //       dataURLtoFile(ImgTypeLaser, "Test.jpg")
  //     );
  //     // download the image async if we want
  //     //download(image, { name: "lorem-ipsum", extension: "png" });
  //     // setDrawerOpened(false);
  //   }
  // }, [ImgTypeLaser]);

  // React.useEffect(() => {
  //   if (ImgLaser) {
  //     handleSceenShorts("laser_images", dataURLtoFile(ImgLaser, "Test.jpg"));
  //   }
  // }, [ImgLaser]);

  const [lazerSize, setLazerSize] = React.useState(20);
  const [erase, setErase] = React.useState(false);

  const [lazerIntensity, setLazerIntensity] = React.useState(1);
  const [paintLazer, setPaintLaser] = React.useState(true);
  const { selectedProduct } = useSelector((state: any) => state.products);
  const [mousePositionArray, setmousePositionArray] = React.useState([]);
  const closeDrawer = () => {
    setDrawerOpened(false);
    setCurrent(1);
  };

  const screenShot = () => {
    if (current === 2) {
      // screenShotHandlerTypeLaser();
      screenShotLaserHandler();
      // screenShotLaserHandler();
      setDrawerOpened(false);
    } else if (current === 1) {
      screenShotLaserHandler();
      setDrawerOpened(false);
    }
    /*  screenShotLaserHandler();
    setDrawerOpened(false); */
  };

  console.log({
    images: globalData.laser_type_images || [],
    front: globalData.tmp_laser_images_design_front || [],
    back: globalData.tmp_laser_images_design_back || [],
  });

  const [open, setOpen] = React.useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <div>
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <Row>
          <Col span={24}>
            <LazerOpenModalButton
              title="You can change the laser design "
              onClick={() => setDrawerOpened(true)}
              type="lazer"
            />
          </Col>
        </Row>
        <Row>
          <textarea
            placeholder="More Details"
            className="textarea-custom"
            rows={3}
            name="laser_details"
            onChange={(e: any) => handleChange(e)}
            value={globalData.laser_details}
            // ref={register({ required: false })}
          />
        </Row>
        {/* <div style={{ alignSelf: "flex-end", marginTop: "auto" }}>
          <OrderButton title="Next" />
        </div> */}
      </div>
      <Drawer
        height={
          window.innerWidth < 769
            ? window.innerHeight - 80
            : window.innerHeight - 100
        }
        maskClosable={false}
        placement="bottom"
        visible={drawerOpened}
        closable={false}
        onClose={() => closeDrawer()}
        title={
          <div className="d-flex justify-content-center align-items-center">
            <h2 className="text-center">
              Laser Intensity {current === 1 ? "Drawing" : "Design"}{" "}
            </h2>
            <Space className="ml-auto">
              <button
                type="submit"
                onClick={screenShot}
                /*  className="order-btn-h" */
                style={{
                  background: "#00468C",
                  color: "white",
                  borderRadius: 5,
                  height: 40,
                  paddingInline: 24,
                  marginRight: 8,
                  fontSize: "16px",
                }}
              >
                Confirm and close
              </button>
              <button
                type="button"
                onClick={showModal}
                /* className="order-btn-h outlined-btn-h" */
                style={{
                  background: "#e3e0e0",
                  color: "white",
                  borderRadius: 5,
                  height: 40,
                  paddingInline: 16,
                  paddingBottom: 7,
                  fontSize: "16px",
                }}
              >
                <CloseOutlined
                  style={{
                    color: "#00468C",

                    fontSize: "16px",
                  }}
                />
              </button>

              <Modal
                title="Changes not saved"
                visible={open}
                maskClosable={false}
                closable={false}
                centered
                onCancel={handleCancel}
                footer={[
                  <button
                    onClick={() => {
                      handleCancel();
                      screenShot();
                    }}
                    key="submit"
                    style={{
                      background: "#00468C",
                      color: "white",
                      borderRadius: 5,
                      height: 40,
                      paddingInline: 24,
                      marginRight: 8,
                    }}
                  >
                    Confirm and close
                  </button>,

                  <button
                    onClick={() => {
                      setDrawerOpened(false);
                      Clear();
                      handleCancel();
                    }}
                    key="submit"
                    style={{
                      background: "white",
                      border: "1px solid #E0E0E0",
                      borderRadius: 5,
                      height: 40,
                      paddingInline: 24,
                      marginRight: 8,
                    }}
                  >
                    Discard changes
                  </button>,

                  <button
                    key="back"
                    onClick={handleCancel}
                    style={{ borderRadius: 5 }}
                  >
                    Cancel
                  </button>,
                ]}
              >
                <p>Would you like to confirm your changes?</p>
              </Modal>
              {/*  {current === 1 ? (
                <button
                  type="button"
                  onClick={screenShotLaserHandler}
                  className="order-btn-h outlined-btn-h"
                >
                  Next
                </button>
              ) : (
                ""
              )} */}
            </Space>
          </div>
        }
      >
        {/* <Row justify="center" style={{ width: "100%" }}>
          <h1>Identify Lazer Area</h1>
        </Row> */}
        {current === 1 ? (
          <Row
            className="container-configurator pt-4"
            ref={laserRef}
            id="capture"
          >
            <Col span={11}>
              <FrontLazerCanvas
                size={lazerSize}
                intensity={lazerIntensity}
                paintLazer={paintLazer}
                mousePositionArray={mousePositionArray}
                mouseMoveFrontLazer={mouseMoveFrontLazer}
                initialDrawing={globalData.tmp_laser_images_drawing_front}
                erase={erase}
                close={close}
                clearButton={clearButton}
              />
            </Col>

            {/*        <button
              className="choose-cursor-btn-configurator mt-3"
              onClick={screenShotLaserHandler}
            >
              <DamageIndicatorIcon />
            </button> 
            <div className="vertical-line"></div>  */}

            <div className="configurator">
              <LazerCanvasConfigurator
                setLazerIntensity={setLazerIntensity}
                setLazerSize={setLazerSize}
                setPaintLaser={setPaintLaser}
                paintLazer={paintLazer}
                setCurrent={setCurrent}
                current={current}
                setEraser={setErase}
              />
            </div>

            <Col span={11}>
              <BackLazerCanvas
                size={lazerSize}
                intensity={lazerIntensity}
                mouseMoveBackLazer={mouseMoveBackLazer}
                initialDrawing={globalData.tmp_laser_images_drawing_back}
                erase={erase}
                clearButton={clearButton}
              />
            </Col>
          </Row>
        ) : (
          current === 2 && (
            /*  <Row
              ref={laserTypeRef}
              id="capture-design"
              className="container-configurator pt-4"
            >
              <LazerCanvasStep2
                setPaintLaser={setPaintLaser}
                setCurrent={setCurrent}
                current={current}
                screenShotHandlerTypeLaser={screenShotHandlerTypeLaser}
                deleteBrush={deleteBrush}
                handleImageTypes={handleImageTypes}
                deleteImageTypes={deleteImageTypes}
                mouseClickFrontLazerDesign={mouseClickFrontLazerDesign}
                mouseClickBackLazerDesign={mouseClickBackLazerDesign}
                initialDesign={{
                  images: globalData.laser_type_images || [],
                  front: globalData.tmp_laser_images_design_front || [],
                  back: globalData.tmp_laser_images_design_back || [],
                }}
                deletePositionFiles={(id: string, attribute: string) =>
                  deletePositionFiles(id, attribute)
                }
              />
              <Col span={21} style={{ marginTop: "200px" }}></Col>
            </Row> */
            <Row
              className="container-configurator pt-4"
              ref={laserRef}
              id="capture"
            >
              <Col span={11}>
                <FrontLazerCanvas
                  size={lazerSize}
                  intensity={lazerIntensity}
                  paintLazer={paintLazer}
                  mousePositionArray={mousePositionArray}
                  mouseMoveFrontLazer={mouseMoveFrontLazer}
                  initialDrawing={globalData.tmp_laser_images_drawing_front}
                  erase={erase}
                  close={close}
                  clearButton={clearButton}
                />
              </Col>

              {/*        <button
              className="choose-cursor-btn-configurator mt-3"
              onClick={screenShotLaserHandler}
            >
              <DamageIndicatorIcon />
            </button> 
            <div className="vertical-line"></div>  */}
              <div className="configurator">
                <LazerCanvasConfigurator
                  setLazerIntensity={setLazerIntensity}
                  setLazerSize={setLazerSize}
                  setPaintLaser={setPaintLaser}
                  paintLazer={paintLazer}
                  setCurrent={setCurrent}
                  current={current}
                  setEraser={setErase}
                />
              </div>

              <Col span={11}>
                <BackLazerCanvas
                  size={lazerSize}
                  intensity={lazerIntensity}
                  mouseMoveBackLazer={mouseMoveBackLazer}
                  initialDrawing={globalData.tmp_laser_images_drawing_back}
                  erase={erase}
                  clearButton={clearButton}
                />
              </Col>
            </Row>
          )
        )}

        {/* <Row
          justify="center"
          align="middle"
          // marginTop: "2.5rem"
          style={{
            zIndex: 99999999,
            marginTop: window.innerWidth < 769 ? "7.8rem" : "0",
          }}
        >
          <button
            type="button"
            onClick={() => setDrawerOpened(false)}
            className="order-btn-h outlined-btn-h"
          >
            Discard
          </button>
          <button type="submit" onClick={screenShot} className="order-btn-h">
            Confirm
          </button>
        </Row> */}
      </Drawer>
    </div>
  );
};

export { LazerForm };
